import {
  FolderOpenIcon,
  LibraryIcon,
  ListTreeIcon,
  PackageSearchIcon,
  RepeatIcon,
  RouteIcon,
  SearchIcon,
  WrenchIcon,
} from 'lucide-react'

export const CHECKOUT_URL = 'https://profesor-tecnico-en-electromecanica.impultienda.ar/checkout'

export const OFFER_ANCHOR = '#oferta'

export const SUPPORT_EMAIL = 'soportescmdigital@gmail.com'

export const PACK_IMAGE =
  'https://cdn.magicpatterns.com/uploads/7TBmYr9SnpX5hQcKY6L145/Imagen_de_ChatGPT_30_sept_2026,_21_28_48.png'

export const PRODUCT_NAME = 'MEGA PACK PROFESOR TÉCNICO EN ELECTROMECÁNICA'
export const PACK_IMAGE_ALT = 'MEGA PACK PROFESOR TÉCNICO EN ELECTROMECÁNICA: 6 tomos digitales y 5 bonos incluidos'
export const PRICE = '$19.990'
export const BONUS_TOTAL = '$39.950'

export const META_PIXEL_ID = '2226605141499138'

/* 1. PROBLEMA */
export const problems = [
  {
    icon: FolderOpenIcon,
    title: 'INFORMACIÓN DISPERSA',
    desc: 'Guardas apuntes, diagramas, actividades, PDFs y videos sobre motores, contactores, automatismos y mantenimiento, pero tienes que organizar todo cada vez que preparas una clase.',
  },
  {
    icon: ListTreeIcon,
    title: 'NO SABES CÓMO ORGANIZAR CADA TEMA',
    desc: 'Motores, relés, contactores, mando, potencia, sensores, automatismos, mantenimiento... hay mucho contenido y necesitas una secuencia clara para enseñarlo.',
  },
  {
    icon: PackageSearchIcon,
    title: 'TE FALTA MATERIAL PRÁCTICO',
    desc: 'Explicar la teoría es solo una parte. También necesitas actividades, diagramas, evaluaciones y proyectos que ayuden a tus alumnos a aplicar lo aprendido.',
  },
  {
    icon: RepeatIcon,
    title: 'SIGUES PREPARANDO TODO DESDE CERO',
    desc: 'Cada semana vuelves a buscar información, crear actividades y organizar prácticas cuando podrías trabajar sobre una estructura ya preparada.',
  },
]

/* 2. SOLUCIÓN — 6 TOMOS */
export const tomos = [
  {
    title: 'FUNDAMENTOS DE ELECTROMECÁNICA Y ELECTRICIDAD INDUSTRIAL',
    desc: 'Trabaja los fundamentos de electricidad y electromecánica, magnitudes eléctricas, Ley de Ohm, corriente alterna, sistemas monofásicos y trifásicos, circuitos, componentes, mediciones, esquemas y seguridad.',
  },
  {
    title: 'MOTORES ELÉCTRICOS: FUNCIONAMIENTO, CONEXIÓN Y DIAGNÓSTICO',
    desc: 'Enseña funcionamiento, partes, motores monofásicos y trifásicos, placas características, cajas de bornes, estrella y triángulo, sentido de giro, protecciones y diagnóstico de fallas.',
  },
  {
    title: 'CONTACTORES, RELÉS Y PROTECCIONES ELÉCTRICAS',
    desc: 'Desarrolla contactores, bobinas, contactos principales y auxiliares, pulsadores, relés, temporizadores, relés térmicos, guardamotores, fusibles y circuitos de mando y potencia.',
  },
  {
    title: 'AUTOMATISMOS, CIRCUITOS DE MANDO Y POTENCIA',
    desc: 'Trabaja marcha y parada, auto-retención, inversión de giro, enclavamientos, temporizadores, estrella-triángulo, sensores, finales de carrera, secuencias automáticas e introducción al PLC.',
  },
  {
    title: 'MANTENIMIENTO ELECTROMECÁNICO Y DETECCIÓN DE FALLAS',
    desc: 'Enseña mantenimiento correctivo, preventivo y predictivo, inspección de motores y tableros, instrumentos de medición y un método ordenado para diagnosticar fallas electromecánicas.',
  },
  {
    title: 'PRÁCTICAS DE TALLER Y PROYECTOS PARA ALUMNOS',
    desc: 'Lleva los conocimientos al taller mediante prácticas con motores, contactores, sensores, temporizadores, mando y potencia, diagnóstico, mantenimiento y proyectos integradores para alumnos.',
  },
]

/* 3. BONOS */
export const bonuses = [
  {
    title: '100 ACTIVIDADES Y TRABAJOS PRÁCTICOS DE ELECTROMECÁNICA',
    desc: 'Banco de actividades sobre electricidad, motores, contactores, mando y potencia, automatismos, mantenimiento y diagnóstico para utilizar en clases, tareas y prácticas de taller.',
    value: '$7.990',
  },
  {
    title: '50 EVALUACIONES Y CUESTIONARIOS DE ELECTROMECÁNICA',
    desc: 'Evaluaciones listas para trabajar fundamentos eléctricos, motores, protecciones, automatismos, mantenimiento y diagnóstico mediante diferentes tipos de ejercicios.',
    value: '$5.990',
  },
  {
    title: '50 DIAGRAMAS Y ESQUEMAS ELÉCTRICOS PARA CLASE',
    desc: 'Biblioteca visual de circuitos, motores, contactores, mando, potencia, sensores y automatismos para explicar, analizar y trabajar esquemas con los alumnos.',
    value: '$6.990',
  },
  {
    title: 'PLANIFICACIONES Y SECUENCIAS DIDÁCTICAS EDITABLES',
    desc: 'Modelos para organizar objetivos, contenidos, actividades, prácticas, evaluaciones y secuencias de clases desde fundamentos eléctricos hasta diagnóstico y automatización.',
    value: '$8.990',
  },
  {
    title: '20 PROYECTOS ELECTROMECÁNICOS PARA ALUMNOS',
    desc: 'Proyectos progresivos para aplicar motores, contactores, sensores, temporizadores, automatismos, mantenimiento y diagnóstico mediante actividades integradoras.',
    value: '$9.990',
  },
]

/* 4. BENEFICIOS */
export const benefits = [
  {
    icon: SearchIcon,
    title: 'MENOS TIEMPO BUSCANDO MATERIAL',
    desc: 'Deja de saltar entre apuntes, videos, PDFs y diagramas y trabaja sobre una ruta organizada desde fundamentos hasta automatismos, mantenimiento y proyectos.',
  },
  {
    icon: LibraryIcon,
    title: 'MÁS RECURSOS PARA TUS CLASES',
    desc: 'Dispón de contenidos, actividades, evaluaciones, diagramas, planificaciones y proyectos que puedes adaptar según tus alumnos y tu institución.',
  },
  {
    icon: WrenchIcon,
    title: 'MÁS PRÁCTICA PARA TUS ALUMNOS',
    desc: 'Complementa las explicaciones con ejercicios, análisis de circuitos, casos de diagnóstico y proyectos que ayuden a aplicar los conceptos.',
  },
  {
    icon: RouteIcon,
    title: 'UNA ENSEÑANZA MÁS ORGANIZADA',
    desc: 'Construye una secuencia que conecte electricidad, motores, contactores, automatismos, mantenimiento y diagnóstico sin tener que empezar cada clase desde cero.',
  },
]

/* 5. TESTIMONIOS */
export const testimonials = [
  {
    quote:
      'Tenía material de motores, contactores y electricidad guardado en diferentes lugares, pero cada vez que preparaba una clase tenía que organizar todo nuevamente. Tener los contenidos separados por tomos me ayudó a seguir una secuencia mucho más clara.',
    author: 'Ricardo Martínez',
    meta: 'Profesor técnico, 42 años · Buenos Aires, Argentina',
  },
  {
    quote:
      'Lo que más necesitaba eran actividades. Explicar la teoría podía hacerlo, pero preparar ejercicios diferentes todas las semanas me llevaba mucho tiempo. El banco de actividades me dio muchas ideas para trabajar con los alumnos.',
    author: 'Javier González',
    meta: 'Instructor técnico, 38 años · Córdoba, Argentina',
  },
  {
    quote:
      'Me sirvió especialmente la parte de motores y automatismos porque pude relacionar los contenidos con prácticas y diagramas. Ahora tengo una estructura que puedo adaptar según el curso.',
    author: 'Mariana Silva',
    meta: 'Docente técnica, 36 años · Montevideo, Uruguay',
  },
  {
    quote:
      'Las evaluaciones y los casos de diagnóstico fueron lo que más aproveché. Me permiten plantear problemas para que los alumnos piensen qué revisar primero en lugar de limitarse a memorizar conceptos.',
    author: 'Carlos Pérez',
    meta: 'Profesor de taller, 45 años · Rosario, Argentina',
  },
  {
    quote:
      'Buscaba material para organizar proyectos de electromecánica y terminé encontrando también planificaciones, diagramas y actividades. Me ayudó a ordenar mucho mejor las prácticas.',
    author: 'Alejandro López',
    meta: 'Instructor de Electromecánica, 40 años · Mendoza, Argentina',
  },
]

/* 6. FAQ */
export const faqs = [
  { q: '¿Es físico o digital?', a: 'Es un producto 100% digital.' },
  {
    q: '¿Necesito ser profesor de Electromecánica?',
    a: 'Está pensado para profesores técnicos, instructores, maestros de taller y personas que preparan material para enseñar Electromecánica, electricidad industrial o automatismos.',
  },
  {
    q: '¿Qué incluye el Mega Pack?',
    a: 'Incluye 6 tomos (fundamentos, motores, contactores y protecciones, automatismos, mantenimiento y diagnóstico, prácticas de taller y proyectos) más 5 bonos complementarios.',
  },
  {
    q: '¿Incluye actividades prácticas?',
    a: 'Sí. Incluye 100 actividades y trabajos prácticos, prácticas de taller con motores, contactores y sensores, y 20 proyectos electromecánicos para alumnos.',
  },
  {
    q: '¿Incluye evaluaciones?',
    a: 'Sí. Incluye 50 evaluaciones y cuestionarios sobre fundamentos eléctricos, motores, protecciones, automatismos, mantenimiento y diagnóstico.',
  },
  { q: '¿Los bonos tienen costo adicional?', a: 'No. Los 5 bonos están incluidos con tu compra.' },
  { q: '¿Es un pago único?', a: 'Sí. Realizas un único pago de $19.990, sin mensualidades.' },
  {
    q: '¿Obtengo acceso inmediatamente?',
    a: 'Sí. Al tratarse de contenido digital, recibirás las instrucciones de acceso después de completar tu compra.',
  },
  {
    q: '¿Puedo adaptar el material a mis clases?',
    a: 'Sí. Las planificaciones son editables y todo el material puede adaptarse al nivel, curso e institución de tus alumnos.',
  },
  {
    q: '¿Esto reemplaza la formación docente o técnica?',
    a: 'No. Es un recurso complementario: no sustituye formación profesional o docente, prácticas supervisadas, documentación de fabricantes ni normativa eléctrica y de seguridad.',
  },
  { q: '¿Dónde solicito soporte?', a: `Puedes escribirnos a ${SUPPORT_EMAIL}.` },
]

/* POP-UP DE COMPRAS RECIENTES — ARGENTINA */
export const recentBuyers = [
  { name: 'Ricardo M.', city: 'Buenos Aires', country: 'Argentina', minutes: 2 },
  { name: 'Graciela P.', city: 'Córdoba', country: 'Argentina', minutes: 4 },
  { name: 'Diego F.', city: 'Rosario', country: 'Argentina', minutes: 6 },
  { name: 'Sergio R.', city: 'Mendoza', country: 'Argentina', minutes: 9 },
  { name: 'Gustavo M.', city: 'La Plata', country: 'Argentina', minutes: 12 },
  { name: 'Claudia V.', city: 'San Miguel de Tucumán', country: 'Argentina', minutes: 15 },
  { name: 'Raúl A.', city: 'Mar del Plata', country: 'Argentina', minutes: 19 },
  { name: 'Patricia L.', city: 'Salta', country: 'Argentina', minutes: 23 },
  { name: 'Hernán S.', city: 'Neuquén', country: 'Argentina', minutes: 28 },
  { name: 'Marcelo T.', city: 'Santa Fe', country: 'Argentina', minutes: 33 },
  { name: 'Pablo D.', city: 'Bahía Blanca', country: 'Argentina', minutes: 39 },
  { name: 'Andrea C.', city: 'Corrientes', country: 'Argentina', minutes: 45 },
]
